export default "__VITE_ASSET__D5p$Cs7u__"